export const XMLParser = {
  parse: function (data: string): Document | undefined {
    if (!window.DOMParser) {
      return undefined;
    }
    const parser: DOMParser = new DOMParser();
    return parser.parseFromString(data, 'text/xml');
  },
  textContent: function (node: any): any {
    let _result: any = '';
    if (node) {
      node.childNodes.forEach((child: any) => {
        switch (child.nodeType) {
          case 3: // TEXT_NODE
          case 2: // ATTRIBUTE_NODE
          case 4: // CDATA_SECTION_NODE
            _result += child.nodeValue;
        }
      });
    }
    return _result;
  },
};
